module.exports = __webpack_public_path__ + "img/9402a02.webp";